// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1KNfX","bigColWidth":"Table_bigColWidth__eBBZa","biggerColWidth":"Table_biggerColWidth__2gvXN","row":"Table_row__1Flmr","col":"Table_col__2iwe5"};